import {DeprecatedCreativeModal as CreativeModal, FlexColumn, Text} from '@forecast-it/design-system';
import {useHistory} from 'react-router-dom';
import React from 'react';

type ActionCompleteGoToLinkModalProps = {
	title: string;
	content: string;
	linkButtonText: string;
	link: string;
	closeButtonText: string;
	closeModal: () => void;
	onStay: () => void;
	dataCy: string;
};

export function ActionCompleteGoToLinkModal({
	title,
	content,
	linkButtonText,
	link,
	closeButtonText,
	onStay,
	closeModal,
	dataCy,
}: ActionCompleteGoToLinkModalProps): JSX.Element {
	const history = useHistory();
	const closeAndStay = () => {
		closeModal();
		if (onStay) {
			onStay();
		}
	};
	const closeAndGoToLink = () => {
		closeModal();
		history.push(link);
	};
	return (
		<CreativeModal
			size={'m'}
			closeModal={closeAndStay}
			creativeButtonText={linkButtonText}
			cancelButtonText={closeButtonText}
			onCreateHandler={closeAndGoToLink}
			title={title}
			disabled={false}
			data-cy={dataCy}
		>
			<FlexColumn>
				<Text>{content}</Text>
			</FlexColumn>
		</CreativeModal>
	);
}
